export default __webpack_public_path__ + "static/media/trash.bd56e605.svg";